// ---------------------------------------------------------------------------
// Booking phone number and email, stored encoded (spam protection, no captcha)
//
// Spam bots mostly collect numbers and addresses by scanning a site's HTML and
// JavaScript files for text that looks like one. These values are stored
// reversed and base64-encoded, so the number and address never appear in any
// file the site serves. They're decoded in the visitor's browser only when the
// booking panel opens or a "Show" button in the Contact section is tapped.
//
// To change one, run this in a terminal and paste the output below:
//   node -e "console.log(Buffer.from([...process.argv[1]].reverse().join('')).toString('base64'))" "new value"
// (phoneTel must start with "tel:+1", e.g. "tel:+15555550100")
// ---------------------------------------------------------------------------
const ENCODED = {
  phoneDisplay: "OTg4OS0yOTIgKTMwOSg=",
  phoneTel: "OTg4OTI5MjMwOTErOmxldA==",
  email: "bW9jLmxpYW1nQDEwcmlhaG53b3JieXR0ZXJQ",
};

function decode(value) {
  return [...atob(value)].reverse().join("");
}

export function getContactDetails() {
  return {
    phoneDisplay: decode(ENCODED.phoneDisplay),
    phoneTel: decode(ENCODED.phoneTel),
    email: decode(ENCODED.email),
  };
}
